import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { Button, InputAdornment, LinearProgress } from "@mui/material"; //FB 7111
import useStyles from "../../../css/styles";
import { ResetUserPassword } from "../../../api";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
//FB 7111
import StrengthMeter from "../../../components/PasswordStrengthMeter";
import { CheckCircle } from "@mui/icons-material";

// Update log
// FB  6192   02/06/2023  DK  Added page to handle Reset password
// FB  7000   06/22/2023  DK  Portal Issues
// FB  7111   07/25/2023  DK  Password strength meter and green tick feature
// FB  7934   12/18/2023  MS  Navigate to login page after restting the password
// FB  8206   02/01/2024  GA  Makovsky Portal - User is redirected to reset password screen after resetting the password
// FB  9207   07/31/2024  MS  Portal - Fixed the navigation after password update

export default function ResetPassword(props: any) {
  const matches = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const styles = useStyles();
  var JSAlert = require("js-alert");
  const [patient, setPatient] = useState({ Password: "", Password2: "" });
  const [errors, setErrors] = useState<any>({});
  //FB 7111
  const [isCriteriaMet, setIsCriteriaMet] = useState(false);
  var login = props.login;
  const data = sessionStorage.getItem("PatientContact");
  if (data != null) {
    var patientContact = JSON.parse(data);
    var login = patientContact.login;
  }
  const handleInputChange = (e: any) => {
    setErrors({ [e.target.name]: false });
    setPatient({
      ...patient,
      [e.target.name]: e.target.value,
    });
  };
  function Validate() {
    //FB 7111
    var regex = RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9\\s])(?=.{8,})");
    if (patient.Password == undefined || patient.Password === "") {
      setErrors((errors: any) => ({ ...errors, Password: true }));
      return false;
    } else if (patient.Password2 == undefined || patient.Password2 === "") {
      setErrors((errors: any) => ({ ...errors, Password2: true }));
      return false;
    } else {
      if (!patient.Password.match(regex)) {
        JSAlert.alert(
          "Password doesn't match the criteria",
          null,
          JSAlert.Icons.Failed
        );
        setErrors((errors: any) => ({
          ...errors,
          Password: true,
          Password2: true,
        }));
        return false;
      }
      if (!(patient.Password === patient.Password2)) {
        JSAlert.alert(
          "Entered passwords doesn't match",
          null,
          JSAlert.Icons.Failed
        );
        setErrors((errors: any) => ({
          ...errors,
          Password: true,
          Password2: true,
        }));
        return false;
      }
    }
    return true;
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (Validate()) {
      const result = await ResetUserPassword(login, patient.Password);
      if (result != null) {
        //FB 7934 BEGIN
        JSAlert.alert("Password reset is successful", null, JSAlert.Icons.Success).then(
          function () {
            // FB  8206 Begin
            //FB 9207
            window.location.href.includes("user/login") ? window.location.reload() : navigate("/user/login");
            //if(window.location.href.includes("user/login"))
              //window.location.reload();
            //else  
              //navigate("/user/login");
            // window.location.reload();
            //FB 8206 End
          }
        );
        //FB 7000 - Removed commented code
        // var alert = JSAlert.alert(
        //   "Password reset is successful",
        //   null,
        //   JSAlert.Icons.Success
        // )
        // alert.then(function () {
        //   //FB 7000
        //   // if (login.length > 0) {
        //   //   window.location.reload();
        //   // } else {
        //   navigate("/user/login");
        //   //}
        // });
        // alert.show();
        //FB 7934 END
      }
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        spacing={2}
        flexDirection="column"
        style={login.length > 0 ? { paddingLeft: "16px" } : {
          paddingLeft: matches == false ? "16px" : "80px",
          marginBottom: "50px",
          marginTop: "16px",
        }}
      >
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            {login.length > 0 ? "" : "Reset Password"}
          </Typography>
        </Grid>
        <hr />
        <Grid item xs={12} sm={6} md={6} lg={4}>
            <TextField
              type="password"
              id="Password"
              name="Password"
              label="New Password"
              value={patient.Password}
              onChange={handleInputChange}
              error={errors.Password}
              variant="standard"
              required
              fullWidth
              // FB 7111
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <CheckCircle style={{ color: isCriteriaMet ? "green" : "lightgray" }} />
                  </InputAdornment>
                ),
              }}
            />
            {/* FB 7111 */}
            <StrengthMeter password={patient.Password} setIsCriteriaMet={setIsCriteriaMet}/>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <TextField
            type="password"
            id="Password2"
            name="Password2"
            label="Confirm Password"
            value={patient.Password2}
            onChange={handleInputChange}
            error={errors.Password2}
            variant="standard"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <h5>Passwords must include:</h5>
          <ul className="list">
            <li>Eight or more characters</li>
            <li>At least one upper and lower case character</li>
            <li>At least one number</li>
            {/* FB 7111 */}
            <li>At least one special character</li>
          </ul>
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          <Button
            type="submit"
            variant="contained"
            className={styles.navigationButton}
          //onClick={handleSubmit}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
